import { jsx as _jsx } from "react/jsx-runtime";
import { noop } from "@sail/utils";
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import KillSwitchContext from "./KillSwitchContext";
import { registerComponentKillCallback } from "../../public/links/createComponentKillswitchLink";
export default function KillSwitchProvider({ children }) {
    const parentContext = useContext(KillSwitchContext);
    const hasParentContext = parentContext[1] !== noop;
    const [localKilledIds, setKilledIds] = useState(new Set());
    const localKillComponents = useCallback((ids)=>{
        setKilledIds((prev)=>{
            const hasNewIds = ids.some((id)=>!prev.has(id));
            if (!hasNewIds) {
                return prev;
            }
            const next = new Set(prev);
            ids.forEach((id)=>next.add(id));
            return next;
        });
    }, []);
    useEffect(()=>{
        if (hasParentContext) {
            // No need to register if we are in a nested provider, our parent will handle it
            return;
        }
        const cleanup = registerComponentKillCallback(localKillComponents);
        return cleanup;
    }, [
        localKillComponents,
        hasParentContext
    ]);
    const killedIds = hasParentContext ? parentContext[0] : localKilledIds;
    const killComponents = hasParentContext ? parentContext[1] : localKillComponents;
    const contextValue = useMemo(()=>[
            killedIds,
            killComponents
        ], [
        killedIds,
        killComponents
    ]);
    return /*#__PURE__*/ _jsx(KillSwitchContext.Provider, {
        value: contextValue,
        children: children
    });
}

//# sourceMappingURL=KillSwitchProvider.js.map